import React from "react";

function Footer() {
    return (
        <footer className="footer-section" style={{backgroundImage: "url(img/footer/bg.png)"}}>
            <div className="container">
                <div className="footer-top py-5">
                    <img src="img/logo-1.png" style={{height: "auto"}} alt="logo"/>
                    <div className="footer-social">
                        <a href="https://www.linkedin.com/in/mario-fern%C3%A1ndez-rodr%C3%ADguez-843b3a91/"><i className="ti-linkedin"></i></a>
                    </div>
                </div>

                
            </div>
        </footer>
    )
}

export default Footer